module.exports = __webpack_public_path__ + "static/media/ICONS_MEDIDAS.eea6ca85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_MEDIDAS.svg
// module id = 487
// module chunks = 0